module.exports = __webpack_public_path__ + "static/media/login_image.e92053e5.png";